import Vue from 'vue'
import Vuex from 'vuex'

import CardData from './card-transaction-data.json'

Vue.use(Vuex)

// TODO: Potentially merge location / category methods and getters into more generic funcs??
// Provide the store with the initial data set
export const store = new Vuex.Store({
  state: { activeLocation: undefined, activeCategory: CardData.categories[0], ...CardData, activeApp: false },
  getters: {
    getCategories: state => state.categories,
    getActiveCategory: state => state.activeCategory,

    getLocations: state => state.locations.slice(0, 10), // Only the first 10 are required as per spec
    getActiveLocation: state => state.activeLocation,

    appIsActive: state => state.activeApp
  },
  mutations: {
    setActiveCategory: (state, payload) => { state.activeCategory = payload },
    sortLocations: (state, sort) => {
      state.locations = state.locations.sort((obj1, obj2) => {
        let _prop1 = obj1.transactions[sort[0]][sort[1]].value
        let _prop2 = obj2.transactions[sort[0]][sort[1]].value

        // HOTFIX to hide colchester in contactless listing
        // TODO: Remove this and update source data object to make robust calculations!
        if (/contactless/i.test(sort[0]) && /all/i.test(sort[1])) {
          if (/colchester/i.test(obj1.name)) _prop1 = 0
          if (/colchester/i.test(obj2.name)) _prop2 = 0
        }

        // Where values are identical, sort locations by name
        if (_prop1 === _prop2) {
          if (obj1.name > obj2.name) return 1
          if (obj1.name < obj2.name) return -1
          if (obj1.name === obj2.name) return 0
        }

        return _prop2 - _prop1
      })
    },
    setActiveLocation: (state, payload) => { state.activeLocation = payload },
    clearActiveLocation: state => { state.activeLocation = undefined },
    setActiveApp: (state, status) => { state.activeApp = status }
  }
})



// WEBPACK FOOTER //
// ./src/store.js